import React from 'react';
import styled from 'styled-components';

const AchievementsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  padding: 40px 20px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Achievement = styled.div`
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
  border: 2px solid rgba(255, 255, 255, 0.3);

  &:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
  }
`;

const AchievementTitle = styled.h3`
  color: #ffe066;
  font-size: 1.4em;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);

  @media (max-width: 480px) {
    font-size: 1.2em;
  }
`;

const AchievementText = styled.p`
  color: #fff;
  font-size: 1em;
  line-height: 1.5;
`;

function Achievements() {
  const achievements = [
    { icon: '🏆', title: 'INVESTIGATIVE GENIUS', text: 'Uncovering truths that matter!' },
    { icon: '📰', title: 'STORYTELLING WIZARD', text: 'Words that captivate millions!' },
    { icon: '🎯', title: 'ACCURACY CHAMPION', text: 'Facts delivered with precision!' },
    { icon: '💪', title: 'FEARLESS REPORTER', text: 'Asking the tough questions!' },
    { icon: '⭐', title: 'AWARD WINNER', text: 'Excellence recognized globally!' },
    { icon: '🐱', title: 'CAT ENTHUSIAST', text: 'Feline friend and fan!' },
    { icon: '🍷', title: 'WINE CONNOISSEUR', text: 'Exquisite taste in every sip!' }
  ];

  return (
    <AchievementsGrid>
      {achievements.map((achievement, index) => (
        <Achievement key={index}>
          <AchievementTitle>{achievement.icon} {achievement.title}</AchievementTitle>
          <AchievementText>{achievement.text}</AchievementText>
        </Achievement>
      ))}
    </AchievementsGrid>
  );
}

export default Achievements;
